<template>
  <div class="goods-item">
    <div>序号{{ index + 1 }}</div>
    <div>
      <el-upload
        action=""
        class="uploader-com"
        :show-file-list="false"
        :on-change="uploadImgChange"
        :auto-upload="false"
        accept="image/*"
        :disabled="handleType == 'preview'"
      >
        <img v-if="item.picUrl" :src="item.picUrl" class="imgel">
        <i v-else class="el-icon-plus uploader-icon" />
      </el-upload>
      <p style="color:#BBBBBB;font-size: 12px;margin-top: 6px;">*添加奖品图片尺寸:1000px*1000px</p>
    </div>
    <div class="goods-details-box">
      <p>奖品类型<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>实物奖品</p>
      <div style="display: flex;align-items: center;width: 100%;gap: 10px;">
        <p><span class="required-point">*</span>奖品名称</p>
        <el-input v-model="item.name" :disabled="handleType == 'preview'" placeholder="奖品简称最多八个汉字" style="width: 175px;" />
        <el-input v-model="item.fullName" :disabled="handleType == 'preview'" placeholder="请输入奖品全称" style="width: 175px;" />
      </div>
      <div style="display: flex;align-items: center;width: 100%;gap: 10px;">
        <p><span class="required-point">*</span>奖品数量</p>
        <el-input v-model="item.stock" :disabled="handleType == 'preview'" type="number" placeholder="请输入奖品数量" style="width: 175px;" />
      </div>
      <div style="display: flex;align-items: center;width: 100%;gap: 10px;">
        <p><span class="required-point">*</span>中奖概率</p>
        <el-input v-model="item.odds" :disabled="handleType == 'preview'" type="number" placeholder="请输入中奖概率" style="width: 175px;" />
        <span>%</span>
      </div>
    </div>
    <div v-if="handleType !='preview'" class="handle-box">
      <template v-if="item.name || item.fullName || item.stock || item.odds || item.picUrl">
        <el-button type="info" size="small" @click="handleAward('reset')">重置</el-button>
      </template>
      <template v-if="item.name && item.fullName && item.stock && item.odds && item.picUrl">
        <el-button type="primary" size="small" @click="handleAward('save')">保存</el-button>
      </template>
      <el-button type="danger" size="small" @click="handleAward('del')">删除</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodAward',
  components: { },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    handleType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {

    };
  },
  watch: {
    'item.name': {
      handler(newVal) {
        const maxlen = 16;
        if (this.byteLen(newVal) > maxlen) {
          this.item.name = this.getMaxlen(newVal, maxlen);
        }
      },
    },
  },
  methods: {
    uploadImgChange(e) {
      const file = e.raw;
      if (file.type.slice(0, 5) !== 'image') {
        this.$message.error('请上传图片');
        return;
      }
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width !== 1000 || img.height !== 1000) {
          this.$message.error(`请上传1000px*1000px的图片`);
          return;
        }
        this.$Api.uploadFile.uploadImage(file, 'lotteryPrize/').then(data => {
          this.uploadLoading = false;
          this.item.picUrl = data;
        });
        this.$message.success('图片上传成功');
      };
    },
    handleAward(e) {
      this.$emit('handleAward', { index: this.index, item: this.item, type: e });
    },
    byteLen (str) {
      str += '';
      var tmp = str.match(/[^\x00-\xff]/g) || [];
      return str.length + tmp.length;
    },
    getMaxlen(str, maxlen) {
      var sResult = ''; var L = 0; var i = 0; var stop = false; var sChar;
      if (str.replace(/[^\x00-\xff]/g, 'xxx').length <= maxlen) {
        return str;
      }
      while (!stop) {
        sChar = str.charAt(i);
        L += sChar.match(/[^\x00-\xff]/) !== null ? 2 : 1;
        if (L > maxlen) {
          stop = true;
        } else {
          sResult += sChar;
          i++;
        }
      }
      return sResult;
    },
  },
};
</script>

<style lang="less" scoped>
.goods-item{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-height: 246px;
  background: #F7F7F7;
  padding: 36px 50px;
  margin-bottom: 30px;
  gap: 60px;
}
/deep/ .uploader-com .el-upload {
  width: 163px;
  height: 163px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .uploader-com.el-upload:hover {
  border-color: #409EFF;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 163px;
  height: 163px;
  line-height: 163px;
  text-align: center;
  background-color: #f7f7f7;
}
.imgel {
  width: 163px;
  height: 163px;
  display: block;
  object-fit: cover;
}
.goods-details-box{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-items: center;
  height: 100%;
  gap: 16px;
  font-size: 14px;
  color: #494949;
}
.required-point{
  color: #FF4D4F;
  margin-right: 2px;
}
.handle-box{
  display: flex;
  align-items: center;
}
</style>

